/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ValidatablePlan } from 'common-typescript';
import { CourseUnit, GradeRaiseAttempt, OtmId } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ComponentDowngradeMappings, ModalService } from 'sis-common';
import { AppErrorHandler, CourseUnitEntityService } from 'sis-components';
import {
    CompletionMethodSelections,
    SelectCompletionMethodComponent,
    SelectCompletionMethodDialogValues,
} from '../../../plan/select-completion-method/select-completion-method.component';

@Component({
    selector: 'app-course-unit-grade-raise-info',
    templateUrl: './course-unit-grade-raise-info.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CourseUnitGradeRaiseInfoComponent implements OnInit {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'student.courseUnitGradeRaiseInfo',
        directiveName: 'appCourseUnitGradeRaiseInfo',
    };

    @Input({ required: true }) gradeRaiseAttempt: GradeRaiseAttempt;
    @Input({ required: true }) validatablePlan: ValidatablePlan;
    @Input() currentAttainmentId: OtmId;
    @Output() selectCompletionMethod = new EventEmitter<CompletionMethodSelections>();

    courseUnit$: Observable<CourseUnit>;

    constructor(
        private modalService: ModalService,
        private courseUnitEntityService: CourseUnitEntityService,
        private appErrorHandler: AppErrorHandler,
    ) {}

    ngOnInit(): void {
        this.courseUnit$ = this.getCourseUnit(this.gradeRaiseAttempt.courseUnitId);
    }

    getCompletionMethodIndex(courseUnit: CourseUnit): number {
        const index = courseUnit.completionMethods
            .map(completionMethod => completionMethod.localId)
            .indexOf(this.gradeRaiseAttempt.completionMethodId);
        return index >= 0 ? index + 1 : undefined;
    }

    openDialog(courseUnit: CourseUnit) {
        this.modalService
            .open(
                SelectCompletionMethodComponent,
                <SelectCompletionMethodDialogValues>{
                    assessmentItemSelections: this.gradeRaiseAttempt?.selectedAssessmentItemIds ?? [],
                    validatablePlan: this.validatablePlan,
                    completionMethodId: this.gradeRaiseAttempt?.completionMethodId,
                    currentAttainmentId: this.currentAttainmentId,
                    courseUnit,
                    isGradeRaiseAttempt: true,
                    gradeRaiseAttempt: this.gradeRaiseAttempt,
                },
                { size: 'sm' },
            )
            .closed.subscribe((completionMethodSelections: CompletionMethodSelections) => {
                this.selectCompletionMethod.emit(completionMethodSelections);
            });
    }

    getOpenDialogTranslationKeyWhenCompletionMethodSelected(courseUnit: CourseUnit): string {
        return courseUnit.completionMethods?.length === 1 ? 'PLAN.VIEW_COMPLETION_METHOD' : 'PLAN.CHANGE_COMPLETION_METHOD';
    }

    getCourseUnit(courseUnitId: OtmId) {
        return this.courseUnitEntityService.getById(courseUnitId).pipe(take(1), this.appErrorHandler.defaultErrorHandler());
    }
}
